import { render, staticRenderFns } from "./AssignmentSubmissionItem.vue?vue&type=template&id=bd1ebaa2&scoped=true&"
import script from "./AssignmentSubmissionItem.vue?vue&type=script&lang=js&"
export * from "./AssignmentSubmissionItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentSubmissionItem.vue?vue&type=style&index=0&id=bd1ebaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1ebaa2",
  null
  
)

export default component.exports